import { LoginCallback } from '@okta/okta-react';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { LoaderLogin } from '@common/components';
import { PATHS } from '@common/constants';
import { useAuth } from '@modules/auth/hooks';

import LoginCallbackError from '../LoginCallbackError/LoginCallbackError';

const LoginCallbackRoute: FC = () => {
  const { authService } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authService.isLoginRedirect()) {
      navigate(PATHS.ROOT);
    }
  }, []);

  return <LoginCallback errorComponent={LoginCallbackError} loadingElement={<LoaderLogin />} />;
};

export default LoginCallbackRoute;
